import axios from 'axios';
import { getConfig } from './config';

const onbClient = axios.create({
    withCredentials: true
});
onbClient.interceptors.response.use(response => response.data);

onbClient.interceptors.request.use(config => {
    config.baseURL = getConfig().onboardingApi;
    return config;
});

export default onbClient;
